import { useState, useEffect } from "react";
import ButtonContainer from "./buttonContainer";
import TextFieldCustom from "../../../../component/elements/textfieldCustom/index";
import { bankDetails } from "../../../../utils/formValidation/validationRules";
import { validateForm } from "../../../../utils/formValidation/validation";

function AccountDetails({ nextHandler, previousHandler, mode, formValues }) {
  const [formData, setFormData] = useState({
    id: null,
    accountNumber: "",
    accountName: "",
    bankName: "",
    routingNumber: "",
  });

  useEffect(() => {
    if (!formValues || typeof formValues !== "object") return;
    setFormData({
      id: formValues.id ?? null,
      accountNumber: formValues.accountNumber ?? "",
      accountName: formValues.accountName ?? "",
      bankName: formValues.bankName ?? "",
      routingNumber: formValues.routingNumber ?? "",
    });
  }, [formValues]);

  const [formErrors, setFormErrors] = useState({});

  const handleChange = (field) => (e) => {
    const value = e.target?.value ?? e;
    setFormData((prev) => ({ ...prev, [field]: value }));
    setFormErrors((prev) => ({ ...prev, [field]: "" })); // clear error on change
  };

  const handleSubmit = () => {
    const hasAnyValue = Object.values(formData).some((val) => val?.toString().trim() !== "");

    if (!hasAnyValue) {
      nextHandler(formData, "bank-details");
      return;
    }

    const errors = validateForm(formData, bankDetails);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      nextHandler(formData, "bank-details");
    }
  };

  return (
    <div>
      <div className="shadow-card py-7 px-6 rounded-[16px] grid gap-3 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2">
        <TextFieldCustom label="Account Number*" fullWidth
          value={formData.accountNumber}
          onChange={handleChange("accountNumber")}
          error={!!formErrors.accountNumber}
          helperText={formErrors.accountNumber || " "} />

        <TextFieldCustom label="Account Name*" fullWidth
          value={formData.accountName}
          onChange={handleChange("accountName")}
          error={!!formErrors.accountName}
          helperText={formErrors.accountName || " "} />

        <TextFieldCustom label="Bank Name*" fullWidth
          value={formData.bankName}
          onChange={handleChange("bankName")}
          error={!!formErrors.bankName}
          helperText={formErrors.bankName || " "} />

        <TextFieldCustom label="Routing Number*" fullWidth
          value={formData.routingNumber}
          onChange={handleChange("routingNumber")}
          error={!!formErrors.routingNumber}
          helperText={formErrors.routingNumber || " "} />
      </div>

      <ButtonContainer handleNext={handleSubmit} handlePrevious={previousHandler} mode={mode} />
    </div>
  );
}

export default AccountDetails;
